// Lib
import { createApi } from "@reduxjs/toolkit/query/react";
// Types
import { UrlQueryParams } from "types/common";
import { GetLogsResponseDto } from "types/logs";
// Utils
import { coreQuery } from "utils/baseQuery";
import { endpoints } from "consts";

export const logsAPI = createApi({
  reducerPath: "logsAPI",
  baseQuery: coreQuery(),
  tagTypes: ["logs"],

  endpoints: build => ({
    getLogs: build.query<
      GetLogsResponseDto,
      {
        query: UrlQueryParams;
      }
    >({
      query: ({ query }) => ({
        url: endpoints.logs,
        method: "GET",
        params: {
          lastEvaluatedKey: query.cursor,
          limit: query.limit,
        },
      }),

      keepUnusedDataFor: 0,

      // Cache single list of logs
      serializeQueryArgs: () => "getLogs",

      merge: (currentCache, newData) => {
        currentCache.items = [...(currentCache.items ?? []), ...newData.items];

        currentCache.lastEvaluatedKey = newData.lastEvaluatedKey;
        currentCache.hasMore = newData.hasMore;
      },

      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.query?.cursor !== previousArg?.query?.cursor;
      },
    }),
  }),
});

export const { useGetLogsQuery } = logsAPI;
